import {mapActions, mapGetters, mapMutations} from 'vuex';
import paginationMixin from '@/mixins/pagination/index.js'
import filterSearch from '@/mixins/filter-search/index.js'
import * as moment from "moment/moment";

export default {
    components:{
        Header: ()=> import('@/components/header/index.vue'),
        leftBar: ()=> import('@/components/left-bar/index.vue'),
        Table: ()=> import('@/components/table/list/index.vue'),
        pagination: ()=> import('@/components/pagination/index.vue'),
        TableOptions: ()=> import('@/components/table/options/index.vue'),
        popup: ()=> import('@/components/popups/contacts/customers/index.vue'),
        carousel: ()=> import('vue-owl-carousel'),
    },
    mixins: [paginationMixin, filterSearch],
    data(){
        return{
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key: 'id',
                    label: 'id'
                },
                {
                    key: 'name',
                    labelKey: 'contactsCustomers.customer'
                },
                {
                    key: 'country',
                    labelKey: 'contactsCustomers.localization'
                },
                {
                    key: 'mobile',
                    labelKey: 'contactsCustomers.phone'
                },
                {
                    key: 'customer_group_id',
                    labelKey: 'contactsCustomers.group'
                },
                {
                    key: 'email',
                    label: 'email'
                },
                {
                    key: 'comment',
                    labelKey: 'contactsCustomers.comment'
                },
                {
                    key: 'added',
                    labelKey: 'contactsCustomers.added'
                },
                {
                    key: 'web-site',
                    labelKey: 'contactsCustomers.site'
                },
                {
                    key: 'ip',
                    labelKey: 'contactsCustomers.ip'
                }
            ],
            items:[],
            selectedItem: null,
            showPopup: false,
            activeStatus: 0,
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide:'config/menuHide',
            customers:'contacts/customers',
            customerGroups:'contacts/customerGroups',
        })
    },
    watch:{
        customers(e){
            this.items = []
            e.data.map(item=>{
                let customGroup = this.customerGroups.data.filter(itemGroup => itemGroup.id === item.customer_group_id);
                if(customGroup.length !== 0){
                    customGroup = customGroup[0].title
                }else{
                    customGroup = ''
                }
                this.items.push({
                    id:item.id,
                    'name': item.name,
                    'country': item.country,
                    'mobile': item.phone,
                    'customer_group_id': customGroup,
                    'email': item.email,
                    'comment': item.comment,
                    'added':  moment(item.created_at).format('YYYY-MM-DD HH:mm'),
                    'web-site': item.site,
                    'ip': item.ip,
                });
            })
            this.res = e
        },
        page() {
            this.searchPayload.page = this.page
            this.searchPayload.per_page = this.per_page
            this.getCustomers(this.searchPayload);
        },
        per_page(e) {
            this.searchPayload.per_page = e
            this.getCustomers(this.searchPayload);
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getCustomerGroups().then(()=>{
            this.getCustomers(this.searchPayload).then(()=>{
                this.toggleLoadingStatus(false);
            });
        })
    },
    methods:{
        removeFilterItem(index){
            this.filterList.splice(index, 1);
            this.createPayloadForSearch();
        },
        getPayloadForSearch(){
            if(this.activeStatus !== 0){
                this.searchPayload['customer_group_id'] = this.activeStatus
                    this.getCustomers(this.searchPayload);

            }else{
                this.getCustomers(this.searchPayload);

            }
        },
        getAllItemsInTable(){
            this.selectedItem = this.items;
            this.$refs.tableComponent.getAllItemsInTable();
        },
        changePopup(item){
            this.showCustomer(item.id)
            this.showPopup = true;
        },
        editClickWarehouse(item){
            this.showCustomer(item.id)
            this.showPopup = true;
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        sendCustomer(form){
            this.addCustomer(form).then(res=>{
                if(res.status){
                    this.getCustomers(this.searchPayload)
                    this.$toasted.success(this.$t('toasts.customer_added'),{
                        duration : 3000
                    });
                }
                this.showPopup = false;
            })
        },
        changeCustomer(form){
            this.editCustomer(form).then(res=>{
                if(res.status){
                    this.getCustomers(this.searchPayload)
                    this.$toasted.success(this.$t('toasts.customer_updated'),{
                        duration : 3000
                    });
                    this.showPopup = false;
                }
            })
        },
        removeItem(id){
            console.log('removeItem', id)
          this.removeCustomer(id).then(res=>{
              if(res.status){
                  this.getCustomers(this.searchPayload)
                  this.$toasted.success(this.$t('toasts.customer_deleted'),{
                      duration : 3000
                  });
                  this.showPopup = false;
              }
          })
        },
        getClientFromStatus(id){
            this.activeStatus = id;
            this.searchPayload['customer_group_id'] = this.activeStatus
            this.getCustomers(this.searchPayload)
        },
        ...mapActions({
            getCustomers:'contacts/getCustomers',
            showCustomer:'contacts/showCustomer',
            editCustomer:'contacts/editCustomer',
            addCustomer:'contacts/addCustomer',
            removeCustomer:'contacts/removeCustomer',
            getCustomerGroups:'contacts/getCustomerGroups',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
